<template>
    <v-panel
        v-model="isShow"
        :mask-closable="false"
        title="选择角色模板"
        width="840"
        min-height="628"
        max-height="628"
        class="create-tpl-panel"
    >
        <div v-spinner="loading" class="roletplcontent">
            <v-spinner :opacity="0.5" size="large"></v-spinner>
            <div
                v-for="item in tplList"
                :key="item.tplId"
                class="roletplitem"
                :class="{ tplselected: item.tplId === selectedTplId }"
                @click="itemClick(item)"
            >
                <div class="roletplicon"><v-icon :name="getTplIcoName(item.tplIcon)"></v-icon></div>
                <div class="roletplitemcontent">
                    <h1 class="roletplTitle">{{ item.tplName }}</h1>
                    <p class="roletpldesc">{{ item.desc }}</p>
                    <div class="roletplline"></div>
                    <div>
                        <div class="roletplpkg">
                            <p class="roletplinfo">
                                <span v-for="(pItem, pIndex) in item.packages" :key="pIndex"> {{ pItem }}</span>
                            </p>
                        </div>
                        <div class="roletpl-pri">
                            <p class="roletplinfo2">权限：{{ item.priNum }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <v-button class="roletpl-jump-btn" status="primary" size="large" @click="jumpEdit">进入编辑</v-button>
    </v-panel>
</template>
<script>
import { Icon } from 'vhtml-ui';

const req = require.context('./assets/icons', false, /[^.]+\.svg$/);
Icon.addSprites(req);

export default {
    components: {},
    props: {
        value: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            loading: true,
            tplData: {},
            tplList: [],
            selectedTplId: -1,
            selectedTplName: ''
        };
    },

    computed: {
        isShow: {
            get() {
                return this.value;
            },
            set(val) {
                if (val) {
                    this.getTplData();
                }
                this.$emit('input', val);
            }
        }
    },

    created() {
        if (this.isShow) {
            this.getTplData();
        }
    },

    methods: {
        getTplIcoName(tplIcon) {
            return `roletpl${tplIcon}`;
        },

        itemClick(item) {
            this.selectedTplId = item.tplId;
            this.selectedTplName = item.tplName;
        },

        jumpEdit() {
            if (this.selectedTplId === -1) {
                this.$message.error('请选择角色模板');
            } else {
                this.$router.push(`/mng/role/create/${this.selectedTplId}/${window.encodeURIComponent(this.selectedTplName)}`);
                this.isShow = false;
            }
        },
        customFn(res) {
            this.loading = false;
            this.$message.error(res?.message || '请求出错');
        },

        getTplData() {
            if (this.tplList.length < 0) {
                this.loading = true;
            }

            this.$ajax.read('/mng/role/RoleTpl', {}, { customFn: this.customFn }).then(
                res => {
                    // {"tpls":[{"tplId":1,"tplName":"超级管理员1","tplIcon":1,"desc":"拥有套餐中最全的可视和业务权限，适合xxx行业，xxx行业的系统管理，文案文案文案","packages":{"10002":"企点服务-精益版","10003":"企点服务-标准版"},"priNum":56},{"tplId":2,"tplName":"在线客服2","tplIcon":2,"desc":"拥有在线客户的接待能力及相应业务的操作权限，适合xxx行业、xxx行业的系统管理","packages":{"100002":"企点电话套餐"},"priNum":24},{"tplId":3,"tplName":"电话客服3","tplIcon":3,"desc":"用户电话客户的接待能力及相应业务的操作权限，适合xxx行业、xxx行业的系统管理","packages":{"100002":"企点电话套餐"},"priNum":10},{"tplId":4,"tplName":"电话客服4","tplIcon":4,"desc":"用户电话客户的接待能力及相应业务的操作权限，适合xxx行业、xxx行业的系统管理","packages":{"100002":"企点电话套餐"},"priNum":10},{"tplId":5,"tplName":"电话客服5","tplIcon":5,"desc":"用户电话客户的接待能力及相应业务的操作权限，适合xxx行业、xxx行业的系统管理","packages":{"100002":"企点电话套餐"},"priNum":10},{"tplId":6,"tplName":"电话客服6","tplIcon":6,"desc":"用户电话客户的接待能力及相应业务的操作权限，适合xxx行业、xxx行业的系统管理","packages":{"100002":"企点电话套餐"},"priNum":10},{"tplId":7,"tplName":"电话客服7","tplIcon":7,"desc":"用户电话客户的接待能力及相应业务的操作权限，适合xxx行业、xxx行业的系统管理","packages":{"100002":"企点电话套餐"},"priNum":10},{"tplId":9,"tplName":"jimm预留1","tplIcon":9,"desc":"jimm预留1jimm预留1jimm预留1jimm预留1jimm预留1jimm预留1jimm预留1jimm预留1jimm预留1jimm预留1","packages":{"100012":"企点电话套餐"},"priNum":10},{"tplId":10,"tplName":"jimm预留2","tplIcon":10,"desc":"jimm预留2jimm预留2jimm预留2jimm预留2jimm预留2jimm预留2jimm预留2jimm预留2jimm预留2jimm预留2","packages":{"100013":"企点电话套餐"},"priNum":10}]};
                    const { tpls } = res || {};
                    if (tpls && tpls.length) {
                        this.tplList = tpls;
                    }
                    this.loading = false;
                },
                error => {
                    this.$message.error((error && error.message) || '请求出错');
                    this.loading = false;
                }
            );
        }
    }
};
</script>

<style lang="less">
@import './index.less';
</style>
